import { render } from "./freeSharesTab.vue?vue&type=template&id=298491ac"
import script from "./freeSharesTab.vue?vue&type=script&lang=ts"
export * from "./freeSharesTab.vue?vue&type=script&lang=ts"

import "./freeSharesTab.vue?vue&type=style&index=0&id=298491ac&lang=scss"
script.render = render

export default script